import { Badge, Group, Text, Tooltip } from '@mantine/core';
import {
  DOMAIN_STATUS_COLOR,
  DOMAIN_STATUS_LABEL,
  dnsHostLabel,
  expiryLabel,
  type DomainAssignmentStatus,
  type DomainListItem,
} from '../../lib/api/domains/autodnsDomains';

/** Gemeinsame Anzeige-Bausteine der Domains (Liste, Detail, Kunden-Fenster). */

const dateFmt = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'medium' });
const dateTimeFmt = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'short', timeStyle: 'short' });

export function formatDomainDate(iso: string | null | undefined): string {
  return iso ? dateFmt.format(new Date(iso)) : '—';
}

export function formatDomainTime(iso: string | null | undefined): string {
  return iso ? dateTimeFmt.format(new Date(iso)) : '—';
}

export function DomainStatusBadge({ status }: { status: DomainAssignmentStatus }) {
  return (
    <Badge size="sm" variant="light" color={DOMAIN_STATUS_COLOR[status]}>
      {DOMAIN_STATUS_LABEL[status]}
    </Badge>
  );
}

export function DnsHostBadge({ host }: { host: DomainListItem['dnsHost'] }) {
  if (!host) return <Text size="sm" c="dimmed">—</Text>;
  const color = host === 'CLOUDFLARE' ? 'orange' : host === 'AUTODNS' ? 'blue' : 'gray';
  return <Badge size="sm" variant="outline" color={color}>{dnsHostLabel(host)}</Badge>;
}

/** Ablaufdatum mit Hinweis-Badge: ≤ 30 Tage und kein Auto-Renew (Server rechnet `renewalWarning`). */
export function DomainExpiry({ domain }: { domain: Pick<DomainListItem, 'expiresAt' | 'expiresInDays' | 'renewalWarning'> }) {
  const rel = expiryLabel(domain.expiresInDays);
  return (
    <Group gap={6} wrap="nowrap">
      <Tooltip label={rel ?? ''} disabled={!rel}>
        <Text size="sm">{formatDomainDate(domain.expiresAt)}</Text>
      </Tooltip>
      {domain.renewalWarning && (
        <Badge size="xs" color="red" variant="filled">
          {domain.expiresInDays != null && domain.expiresInDays < 0 ? 'abgelaufen' : 'läuft ab · kein Auto-Renew'}
        </Badge>
      )}
    </Group>
  );
}
